import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonGroup, Flex, Heading, Text, Tooltip } from 'core/components';
import { Position } from '@blueprintjs/core';
import KentikLogo from 'app/components/KentikLogo';
import { TbClockHour8, TbDeviceTv, TbDeviceTvOff, TbRefresh } from 'react-icons/tb';
import { withTheme } from 'styled-components';

@inject('$app')
@withTheme
@observer
class BoardKioskHeader extends Component {
  static defaultProps = {
    justifyContent: 'space-between'
  };

  render() {
    const { $app, board, theme } = this.props;

    if (!$app.isKioskMode) {
      return null;
    }

    const hasUdePanel = board.panelCollection.some((panel) => panel.get('type') === 'ude');

    return (
      <Flex alignItems="center" borderBottom="thin" justifyContent="space-between" gap={3} p="8px 32px 8px 16px">
        <Flex alignItems="center" gap={2} flex="1 1 auto">
          <KentikLogo blackText={theme.name === 'light'} style={{ width: 200, height: 29, margin: '0' }} />
          <Heading level={4} m={0}>
            {board.get('title')}
          </Heading>
        </Flex>

        <Flex alignItems="center" gap={1} flex="1 1 auto" justifyContent="flex-end">
          {/* TODO replace with real time selector component */}
          {hasUdePanel && (
            <>
              <ButtonGroup>
                <Button
                  icon={TbClockHour8}
                  rightIcon="caret-down"
                  text={
                    <>
                      Last 3 hours <Text muted>UTC</Text>
                    </>
                  }
                />
                <Button icon={TbRefresh} onClick={() => null} />
              </ButtonGroup>
            </>
          )}

          <Tooltip content="Fullscreen Mode" position={Position.BOTTOM_LEFT}>
            <Button
              minimal
              icon={$app.isKioskMode ? TbDeviceTvOff : TbDeviceTv}
              onClick={() => $app.toggleKioskMode()}
            />
          </Tooltip>
        </Flex>
      </Flex>
    );
  }
}

export default BoardKioskHeader;
